<!--
 * @Descripttion: 房产公文
 * @Author: chenjinsheng
 * @Date: 2021-08-10 16:14:42
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-26 14:59:24
-->
<template>
    <div v-if="checkPermission('UDWWB_OFFICIAL_SYSTEM')" class="docs-container">
        <el-tabs v-if="tabList.length === 0" v-model="activeName">
            <el-tab-pane label="公文" name="公文" />
        </el-tabs>
        <el-tabs v-else v-model="activeName" @tab-click="tabClick">
            <el-tab-pane v-for="{ title, key } in tabList" :key="key" :label="title" :name="key" />
        </el-tabs>
        <div class="content-box">
            <div v-show="isFirstBar" class="doc-menu-sidebar">
                <el-menu
                    :default-active="selectedMenu"
                    background-color="#fff"
                    active-text-color="#47A489"
                    text-color="#666666"
                    @select="menuSelect"
                >
                    <el-menu-item v-for="(item, index) in sideBarList" :key="index" :index="index.toString()">
                        <span slot="title">{{ item.orgName }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div v-show="isFourBar" class="doc-menu-sidebar">
                <el-menu
                    :default-active="selectedMenu"
                    background-color="#fff"
                    active-text-color="#47A489"
                    text-color="#666666"
                    @select="menuSelect"
                >
                    <el-menu-item v-for="(item, index) in sideBarList" :key="index" :index="index.toString()">
                        <span slot="title">{{ item.orgName }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div :class="['docs-box', { 'auto-width': !isSideBar }]">
                <div v-loading="loading" :class="['table-content', { 'no-data': noData }]">
                    <div v-for="(item, index) in docData" :key="index" class="doc-item" @click="openWin(item.link)">
                        <span class="sub"><span v-if="item.isShowNew" class="new">[新] </span>{{ item.subject }}</span
                        ><span class="dateBox">{{ item.publishtime | timeFilters }}</span>
                    </div>
                    <div v-show="noData" class="noData">
                        <no-empty>暂无数据</no-empty>
                    </div>
                </div>
                <div :class="['more', { 'auto-width': !isSideBar }]">
                    <span @click="viewMore"> 查看更多</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { officialQuery, officialDetail } from "@/api";
import NoEmpty from "@/components/no-empty";
import { getDateTimeStamp, treeToArray } from "@/libs/mUtils";
import { Table } from "element-ui";
import _ from "lodash";

const orgMap = new Map([
    ["second", "集团总部"],
    ["third", "新希望服务"],
]);

export default {
    components: {
        NoEmpty,
    },
    data() {
        return {
            selectedMenu: "0",
            firstKey: 0,
            fourthKey: 0,
            activeName: "zero",
            params: {
                current: 1,
                fdMainDept: "",
                title: "",
                size: 75,
            },
            loading: false,
            allDocs: [],
            docData: [],
            sideBarList: [],
            tabList: [],
        };
    },
    computed: {
        isSideBar() {
            return ["first", "fourth"].includes(this.activeName);
        },
        isFirstBar() {
            return this.activeName === "first";
        },
        isFourBar() {
            return this.activeName === "fourth";
        },
        noData() {
            return !this.docData || this.docData.length === 0;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        /**
         * @description: 获取公文列表
         * @param {*}
         * @return {*}
         */
        async init() {
            this.loading = true;
            try {
                const { body, code, message } = await officialQuery();
                if (code === "0000") {
                    const nodes = treeToArray(_.cloneDeep(body));
                    this.allDocs = nodes;
                    this.tabList = [
                        {
                            title: "全部",
                            key: "zero",
                            treeData: [],
                        },
                        {
                            title: "房产公文",
                            key: "first",
                            treeData: this.filterCompany(nodes, ["集团总部", "新希望服务"]),
                        },
                        {
                            title: "集团公文",
                            key: "second",
                            treeData: [],
                        },
                        {
                            title: "新服公文",
                            key: "third",
                            treeData: [],
                        },
                        {
                            title: "城市公文",
                            key: "fourth",
                            treeData: this.filterCompany(nodes, "公司"),
                        },
                    ];
                    this.initSideBar("zero");
                    this.docDetail();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },

        /**
         * @description: 获取公文详情
         * @param {*} orgId
         * @return {*}
         */
        async docDetail(orgId = "") {
            this.loading = true;
            try {
                const { body = [], code, message } = await officialDetail({
                    ...this.params,
                    fdMainDept: orgId,
                });
                if (code === "0000") {
                    const list = body ? body.records : [];
                    this.docData = list.map((item) => {
                        let timeDis = new Date().getTime() - getDateTimeStamp(item.publishtime);
                        return {
                            ...item,
                            isShowNew: timeDis / (3600 * 1000 * 24) < 3,
                        };
                    });
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },

        // 切换tab标题
        tabClick({ name }) {
            this.initSideBar(name);
            switch (name) {
                case "zero":
                    this.all();
                    break;
                case "second":
                case "third":
                    this.searchDoc(name);
                    break;
                default:
                    this.other();
                    break;
            }
        },
        // 重置菜单选中状态
        resetMenuStatus() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const selectors = document.querySelectorAll(".doc-menu-sidebar .el-menu-item");
                    for (let el of selectors) {
                        el.setAttribute("class", "");
                        el.setAttribute("class", "el-menu-item");
                    }
                    selectors[0].setAttribute("class", "el-menu-item is-active");
                }, 500);
            });
        },
        // 创建左侧导航栏
        initSideBar(name) {
            this.sideBarList =
                _.get(
                    this.tabList.find(({ key }) => key === name),
                    "treeData"
                ) || [];
        },

        // 查看全部
        all() {
            this.docDetail();
        },

        // 查询集团公文及新服公文
        searchDoc(name) {
            const { orgIds = "" } = _.head(this.allDocs.filter((item) => item.orgName === orgMap.get(name)));
            this.docDetail(orgIds);
        },

        // 查看其他
        other() {
            let key = 0;
            if (this.activeName === "first") {
                key = this.firstKey;
            }

            if (this.activeName === "fourth") {
                key = this.fourthKey;
            }
            const { orgIds = "" } = this.sideBarList[key];
            this.docDetail(orgIds);
        },

        // 过滤房产公司
        filterCompany(data = [], key) {
            const orgs = _.cloneDeep(data);
            if (typeof key === "string") {
                return orgs.filter(({ orgName }) => orgName.includes(key));
            }
            return orgs.filter(({ orgName }) => !key.includes(orgName));
        },

        // 链接新切页面
        openWin(src) {
            window.open(src);
        },

        // 左侧菜单切换
        menuSelect(key) {
            if (this.activeName === "first") {
                this.firstKey = key;
            }

            if (this.activeName === "fourth") {
                this.fourthKey = key;
            }
            const sideItem = this.sideBarList[key];
            this.docDetail(sideItem.orgIds);
        },
        viewMore() {
            this.$router.push({
                name: "SystemManage",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
